<template>
  <div>
    <FormRegisterSection1 v-if="activeSection == REGISTER_SECTION_ONE"
      @handleActiveSection="handleActiveSection"
      @handleVerificationKey="handleVerificationKey"
      @handleEmail="handleEmail"
    />
    <FormRegisterSection2 v-else-if="activeSection == REGISTER_SECTION_TWO"
      @handleActiveSection="handleActiveSection"
      :verificationCode="verificationCode"
      :email="email"
    />
    <FormRegisterSection3 v-else-if="activeSection == REGISTER_SECTION_THREE"/>
  </div>
</template>

<script>
import FormRegisterSection1 from "./FormRegisterSection1.vue";
import FormRegisterSection2 from "./FormRegisterSection2.vue";
import FormRegisterSection3 from "./FormRegisterSection3.vue";
import { REGISTER_SECTION_ONE, REGISTER_SECTION_TWO, REGISTER_SECTION_THREE } from "../../../constents/app";

export default {
  components: {
    FormRegisterSection1,
    FormRegisterSection2,
    FormRegisterSection3,
  },
  data() {
    return {
      REGISTER_SECTION_ONE,
      REGISTER_SECTION_TWO,
      REGISTER_SECTION_THREE,
      activeSection: REGISTER_SECTION_ONE,
      verificationCode: '',
      email: ''
    };
  },
  methods: {
    handleActiveSection(id) {
      this.activeSection = id
    },
    handleVerificationKey(key) {
      this.verificationCode = key
    },
    handleEmail(email) {
      this.email = email
    }
  }
};
</script>